import {createSelector} from "@reduxjs/toolkit";
import {
  lastOrderSelector,
  modalOrderIdSelector,
  ordersSelector,
  ordersStatusSelector,
  preBookOrdersSelector,
  requestTypeSelector,
} from "./ordersSlice";
import {isEmpty} from "es-toolkit/compat";

export const selectOrdersData = createSelector([ordersSelector], orders => {
  return Array.isArray(orders) && !isEmpty(orders) ? orders : [];
});

export const selectPreBookOrdersData = createSelector([preBookOrdersSelector], preOrders =>
  !isEmpty(preOrders) ? preOrders : [],
);

export const selectLatestOrder = createSelector([lastOrderSelector], latestOrder =>
  !isEmpty(latestOrder) ? latestOrder : {},
);

export const selectModalOrderId = createSelector([modalOrderIdSelector], modalOrderId => modalOrderId ?? "");

export const selectOrdersRequestType = createSelector([requestTypeSelector], requestType => requestType ?? "");

export const selectOrdersStatus = createSelector([state => state.orders], state => ({
  hasFailed: state.hasFailed,
  isFetching: state.isFetching,
  errorMsg: state.errorMsg,
}));
